module.exports = __webpack_public_path__ + "static/media/btn-overlay.f1b72848.png";